import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-welcome-profile',
  templateUrl: './welcome-profile.component.html',
  styleUrls: ['./welcome-profile.component.scss']
})
export class WelcomeProfileComponent implements OnInit {

  constructor( public dataService: DataService ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/welcome-profile/welcome-profile.component.ts